// router.js

import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import routes from "./routes";

Vue.use(VueRouter);
Vue.use(VueMeta);

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
function authMiddleware(to, from, next) {
  // Check if the route requires authentication
  if (to.meta.authRequired) {
    // Check if the user is logged in
    if (!localStorage.getItem("user_info")) {
      // If not logged in, redirect to login page
      next("login");
    } else {
      // Get the user's roles from localStorage
      const userRoles = JSON.parse(localStorage.getItem("user_info")).Roles;

      // Get the required permissions for the route
      const requiredPermissions = to.meta.permissions || [];

      // Check if any of the user's roles have the required permissions
      const hasPermission =
        requiredPermissions.length === 0 ||
        requiredPermissions.some((permission) =>
          userRoles.includes(permission)
        );

      if (hasPermission) {
        // User has the required permission, proceed to the next navigation hook
        next();
      } else {
        // User is not authorized, redirect to an error page or display an error message
        next("/error/403");
      }
    }
  } else {
    // If the route does not require authentication, proceed
    next();
  }
}

// Before each route navigation, apply the auth middleware
router.beforeEach((to, from, next) => {
  authMiddleware(to, from, next);
});

// Before resolving each route, also apply the auth middleware
router.beforeResolve((to, from, next) => {
  authMiddleware(to, from, next);
});

export default router;
